var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgQceIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-Default"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Default",
    clipPath: "url(#clip-Default)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1691",
    "data-name": "Group 1691",
    transform: "translate(-0.26 1)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_357",
    "data-name": "Path 357",
    d: "M17.427,1H6.747A2.487,2.487,0,0,0,4.26,3.487v13.32a2.487,2.487,0,0,0,2.487,2.487h5.207a2.583,2.583,0,0,1,.573-1.333l.007-.007V16.927a3.868,3.868,0,0,1,2.533-3.64,1.638,1.638,0,0,1,2.713,0,4.1,4.1,0,0,1,.8.407A3.922,3.922,0,0,1,19.913,15.2V3.487A2.487,2.487,0,0,0,17.427,1Zm-9.3,11.44a.91.91,0,1,1,.907-.907A.91.91,0,0,1,8.127,12.44Zm0-3.307a.91.91,0,1,1,.907-.913.91.91,0,0,1-.907.913Zm0-3.313a.91.91,0,1,1,.907-.907A.91.91,0,0,1,8.127,5.82ZM17.04,12.2h-5.7a.667.667,0,0,1,0-1.333h5.7a.667.667,0,0,1,0,1.333Zm0-3.313h-5.7a.667.667,0,0,1,0-1.333h5.7a.667.667,0,0,1,0,1.333Zm0-3.307h-5.7a.667.667,0,0,1,0-1.333h5.7a.667.667,0,0,1,0,1.333Z",
    transform: "translate(0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_358",
    "data-name": "Path 358",
    d: "M23.65,24.65V23.21A2.889,2.889,0,0,0,21.4,20.4a.664.664,0,0,0-.647-.547.657.657,0,0,0-.64.547A2.888,2.888,0,0,0,17.87,23.21v1.447a1.541,1.541,0,0,0-.567.92,1.609,1.609,0,0,0-.033.313.669.669,0,0,0,.667.667H20.09v.06a.667.667,0,1,0,1.333,0v-.06h2.16a.669.669,0,0,0,.667-.667A1.584,1.584,0,0,0,23.65,24.65Z",
    transform: "translate(-4.337 -6.283)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQceIcon);
export default __webpack_public_path__ + "static/media/qceIcon.7e5fe0bff79a6c075eeaf45ea067bf20.svg";
export { ForwardRef as ReactComponent };